// extracted by mini-css-extract-plugin
export default {"noDataCard":"NoDataCard--noDataCard--7mG9v","message":"NoDataCard--message--FNsoT","buttonContainer":"NoDataCard--buttonContainer--niZYe"};